import { Enterprise } from 'models/Enterprises';

export type EnterpriseTable = Pick<Enterprise, '_id' | 'brandName'> &
  Record<
    | 'principal'
    | 'businessUnits'
    | 'employeesCount'
    | 'dealsCount'
    | 'manageLink'
    | 'editLink'
    | 'analyticsLink',
    string
  >;

export const TABLE_COLUMNS: Array<keyof EnterpriseTable> = [
  'brandName',
  'principal',
  'businessUnits',
  'employeesCount',
  'dealsCount',
  'manageLink',
  'editLink',
  'analyticsLink',
];

export const HEADING_TRANSLATIONS = {
  brandName: 'name',
  principal: 'principal',
  businessUnits: 'businessUnits',
  employeesCount: 'employees',
  dealsCount: 'deals',
  manageLink: '',
  editLink: '',
  analyticsLink: '',
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  brandName: 200,
  principal: 200,
  businessUnits: 100,
  employeesCount: 100,
  dealsCount: 100,
};
